import { z } from "zod";
export const PromptSearchParamsSchema = z.object({
    query: z
        .string()
        .min(1)
        .describe("Search query for the prompt library (natural language is fine)."),
    tags: z
        .array(z.string())
        .optional()
        .describe("Optional tag filters (section must include all tags)."),
    limit: z
        .number()
        .int()
        .positive()
        .optional()
        .describe("Max number of results to return (default 8, max 20)."),
});
